import { getWindow } from './getWindow.tsx';

export const getDocument = (): Document | undefined => getWindow()?.document;
